/* eslint-disable prefer-promise-reject-errors */
import axios from 'axios';
import Cookies from './Cookies';
import { BucketAssignment } from '../SharedTypes';
import { getApimBaseUrl } from '../utilities';
import { API_TIMEOUT } from '../constants';

type SplitTestResponse = {
  data: {
    content: {
      bucketKey: 'string';
    };
  };
};

function getExperiment(
  environment,
  name,
  identifier
) {
  const apimBaseUrl = getApimBaseUrl(environment);
  return axios({
    method: 'post',
    url: `https://${apimBaseUrl}/splittest/api/v2/buckets`,
    data: {
      experimentName: name,
      identifier,
    },
    timeout: API_TIMEOUT,
  });
}

export default (async function FetchExperimentWithIdentifier({
  name,
  identifier,
  environment = process.env.NODE_ENV,
  cacheMinutes = 15,
  killSwitch
}): Promise<BucketAssignment> {
  if (killSwitch === 'on') {
    return {
      assignedBucket: undefined,
      experimentName: name
    };
  }

  return getExperiment(environment, name, identifier)
    .then((response: SplitTestResponse) => {
      const { data: { content: { bucketKey } } } = response;
      if (cacheMinutes !== 0 && bucketKey) {
        Cookies.set(name, bucketKey, cacheMinutes);
      }
      return {
        assignedBucket: bucketKey,
        experimentName: name,
      };
    }).catch(() => ({
      assignedBucket: undefined,
      experimentName: name,
    })
    );
});
